export const ENDPOINT = "https://crown.munvo.com/api/v1";
//export const ENDPOINT='http://crown.munvo.com:5000/api/v1'
//
export const LOGINPAGE = "https://crown.munvo.com/login?next=%2F";
export const LOGOUT = "https://crown.munvo.com/logout";
